import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_follow_any_of_the_following_practices_related_to_c'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_follow_any_of_the_following_practices_related_to_c',
  name: 'Does the facility follow any of the following practices related to contracts?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'WHEN_MAKING_CHANGES_TO_CONTRACTS_THE_FACILITY_DOES_NOT_SEEK_THE',
      text: 'When making changes to contracts, the facility does not seek the written agreement of the affected worker',
      externalIds: [
        {
          id: 'rh-emp-13',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SIGNED_COPIES_OF_CONTRACTS_BETWEEN_THE_FACILITY_AND_EACH_WORKER',
      text: 'Signed copies of contracts between the facility and each worker are not maintained on file',
      externalIds: [
        {
          id: 'rh-emp-14',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CONTRACTS_DO_NOT_CLEARLY_AND_ACCURATELY_STATE_THE_TERMS_AND_CON',
      text: 'Contracts do not clearly and accurately state the terms and conditions of employment',
      externalIds: [
        {
          id: 'rh-emp-15',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'COPIES_OF_CONTRACTS_ARE_NOT_PROVIDED_TO_WORKERS_IN_LINE_WITH_AP',
      text: 'Copies of contracts are not provided to workers, in line with applicable legal requirements',
      externalIds: [
        {
          id: 'rh-emp-16',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'rh-emp-17',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'WHEN_MAKING_CHANGES_TO_CONTRACTS_THE_FACILITY_DOES_NOT_SEEK_THE',
                'SIGNED_COPIES_OF_CONTRACTS_BETWEEN_THE_FACILITY_AND_EACH_WORKER',
                'CONTRACTS_DO_NOT_CLEARLY_AND_ACCURATELY_STATE_THE_TERMS_AND_CON',
                'COPIES_OF_CONTRACTS_ARE_NOT_PROVIDED_TO_WORKERS_IN_LINE_WITH_AP',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'rh-emp-4',
      version: '1.5.0',
      provider: 'slcp',
    },
  ],
  sortingId: 6010,
  sectionId: '2.2.4',
  impactArea: 'Contracts and HR',
  impactAreaId: 'CONTRACTS_AND_TERMS_OF_EMPLOYMENT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
